import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { ComplaintModalContent } from '../ComplaintModalContent';
import { IOffer } from 'shared/types/offers';

export interface IComplaintProps {
  openModal: boolean;
  onCloseModal(): void;
  offer: IOffer;
}

export const ComplaintModal: React.FC<IComplaintProps> = props => {
  const { onCloseModal, openModal, offer } = props;

  return (
    <ModalWindow
      size="XS"
      width={600}
      open={openModal}
      onClose={onCloseModal}
      content={openModal && <ComplaintModalContent offer={offer} onCloseModal={onCloseModal} />}
    />
  );
};
